import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputTextAreaSF from '../../../widgets/form/InputTextAreaSF'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputSelectUI from '../../../widgets/form/InputSelectUI'
import InputReadOnlyUI from '../../../widgets/form/InputReadOnlyUI'

const UpdateAssignedUserModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  //
  assignedUserId, onAssignedUserIdChange, assignedUserIdList, assignedUserIdError, setAssignedUserIdError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update underwriter'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectSF type='text' name='assignedUserId' label='Underwriter'
      value={assignedUserId} onChange={onAssignedUserIdChange} optionList={assignedUserIdList}
      error={assignedUserIdError} setError={setAssignedUserIdError}
    />
  </ModalFormUI>

export default UpdateAssignedUserModalUI
